import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function SundeepDugar() {
  const sundeepDugarSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Dr. Sundeep Dugar",
    "jobTitle": "Drug Discovery",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/sundeep-dugar"
  };

  return (
    <div className="seniorManagementBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Dr. Sundeep Dugar - Drug Discovery"
        description="Dr. Sundeep Dugar has over 30 years of experience in drug discovery and development across oncology, cardiovascular, and metabolic diseases."
        keywords={['Sundeep Dugar', 'Drug Discovery', 'Pharmaceutical Development', 'Zetia', 'Vytorin']}
        ogImage="/sundeepDugar.webp"
        schema={sundeepDugarSchema}
      />

      <div className="xl:page-width px-12 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[2rem]" aria-label="Breadcrumb">
          <Link to="/leadership/senior-management" className="text-white hover:text-primary-red transition-colors">
            Senior Management
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Dr. Sundeep Dugar</span>
          </div>
        </nav>

        <div className="flex flex-col gap-2 md:gap-4 pt-24">
          <div className="text-[4.8rem] font-bold leading-[5.1rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Dr. Sundeep Dugar
          </div>
          <div className="font-syne font-bold text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Drug Discovery
          </div>
        </div>
      </div>

      <div className="pt-[50px] xl:pt-[90px] xl:pb-[80px] xl:page-width px-12">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/sundeepDugar.webp" 
                alt="Dr. Sundeep Dugar, Drug Discovery: Renowned Leader in Oncology, Cardiovascular, and Metabolic Drug Development" 
                className="w-full max-w-[300px] mx-auto md:max-w-[300px] md:mx-0"
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="font-sans text-[2.1rem] leading-[3.1rem] tracking-[.042rem] text-white">
                Dr. Sundeep Dugar (drug discovery) has over 30 years of experience in drug discovery and development across oncology, cardiovascular, and metabolic diseases. He has held leadership roles at Schering-Plough, Bristol-Myers Squibb, and Johnson & Johnson, where he played a key role in the $2.4 billion acquisition of Scios and the licensing of Xarelto. A co-inventor of the blockbuster drugs Zetia® and Vytorin®, he has received prestigious awards for his contributions to chemistry and pharmaceuticals. Dr. Dugar holds a Ph.D. from UC Davis and completed postdoctoral research at ETH Zurich and Cornell University.
              </div>
              

            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="sundeep-dugar" 
        basePath="/leadership" 
      />
    </div>
  );
}